module.exports = __webpack_public_path__ + "static/media/error.a0a949df.mp3";